import { getProductsByKey } from '@/apis/base';

const PAGE_SIZE = 20;
const PAGE_INDEX = 1;

export default {
  namespaced: true,
  state: () => {
    return {
      key: '',
      productList: [],
      pageInfo: {
        pageIndex: PAGE_INDEX,
        pageSize: PAGE_SIZE
      }
    };
  },
  mutations: {
    setProductsByKey (state, payload) {
      state.productList = payload;
    },
    setPageInfo (state, payload) {
      state.pageInfo = payload;
    },
    setKey (state, payload) {
      state.key = payload;
    }
  },
  actions: {
    async getProductsByKey ({ commit, state }, { key, pageIndex = PAGE_INDEX, pageSize = PAGE_SIZE }) {
      console.log(pageIndex, pageSize, 1111111111);
      let res = await getProductsByKey(
        key || state.key,
        pageIndex,
        pageSize
      );
      const data = res._data;
      commit('setProductsByKey', data.productList);
      commit('setPageInfo', data.pageInfo);
      (key !== undefined) && commit('setKey', key);
    }
  }
};



// WEBPACK FOOTER //
// ./src/projects/hsbpc/views/search/store.js